var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-sm-column flex-md-row justify-content-between"},[_c('player',{attrs:{"topic":_vm.selected,"config":_vm.playerOptions,"onboarding":_vm.onboarding},on:{"next":_vm.nextVideo}}),_vm._v(" "),_c('playlist',{attrs:{"onboarding":_vm.onboarding,"topics":_vm.topics},on:{"selected":_vm.selectedVideo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }